/* import __COLOCATED_TEMPLATE__ from './fin-testing-suite-sheet.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import { action } from '@ember/object';
import Component from '@glimmer/component';

interface InstructionBlock {
  text?: string;
  type: 'paragraph' | 'unorderedList';
  items?: string[];
}

interface Signature {
  Args: {
    model: {
      open?: boolean;
      onClose: () => void;
      workflowId?: string;
      externalTaskStepId?: string;
      appId?: string;
      instructions?: InstructionBlock[][];
      guidelines?: InstructionBlock[];
    };
  };
}

export default class FinTestingSuiteSheet extends Component<Signature> {
  @action
  onClose() {
    this.args.model.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::Workflows::FinTestingSuiteSheet': typeof FinTestingSuiteSheet;
    'react/workflows/fin-testing-suite-sheet': typeof FinTestingSuiteSheet;
  }
}
